import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../SubMenus/FootWear.css";
import menFootwear from "../assets/menFootwear.jpg";
import WomanFootwear from "../assets/WomanFootwear.jpg";
import ChildrenFootwear from "../assets/kidsFootwear.jpg";
import kidsFootwear from "../assets/ChildrenFootwear.jpg";

const collections = [
  {
    title: "Men’s Collection",
    image: menFootwear,
    link: "/products/footwear/men-footwear",
  },
  {
    title: "Women’s Collection",
    image: WomanFootwear,
    link: "/products/footwear/women-footwear",
  },
  {
    title: "Kid’s Collection",
    image: kidsFootwear,
    link: "/kids",
  },
  {
    title: "Children Collection",
    image: ChildrenFootwear,
    link: "/children",
  },
];

export default function FootWears() {
  return (
    <div className="products-container" style={{marginBottom:"30px"}}>
      <h2 className="products-heading">Footwear Collections</h2>
      <div className="products-grid">
        {collections.map((item, index) => (
            
          <motion.div
            key={index}
            className="product-card"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            
            <Link to={item.link}>
              <img src={item.image} alt={item.title} className="product-img" />
              <div className="product-overlay">
                <h3>{item.title}</h3>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
